var MuiTextField = {
    root: {
        // Account for the inset label in Text Field
        marginTop: 12,
    },
};
export default MuiTextField;
//# sourceMappingURL=MuiTextField.js.map